import { useField } from 'formik'
import React, { ReactNode } from 'react'

import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import styled from 'styled-components'
import { addErrorDataAttribute } from './utils'
import { Input, InputProps } from '../ui/form/Input'
import { Label } from '../ui/form/Label'

interface Props extends Omit<InputProps, 'name' | 'value' | 'onChange'> {
  name: string
  label?: string
  labelColor?: string
  errorLabelColor?: string
  bgColor?: string
  sideButton?: ReactNode
  required?: boolean
  onChange?: (value: string) => void
}

export const SmartInput: React.FC<Props> = ({
  name,
  label,
  labelColor,
  errorLabelColor,
  bgColor,
  sideButton,
  required,
  onChange,
  ...inputProps
}) => {
  const [field, meta, helpers] = useField(name)

  const isInvalid = Boolean(meta.error && meta.touched)

  return (
    <div>
      {label && (
        <Label htmlFor={name} color={labelColor}>
          {label} {required ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}
      <Input
        id={name}
        name={name}
        bgColor={bgColor}
        sideButton={sideButton}
        {...inputProps}
        value={field.value}
        onChange={value => {
          helpers.setValue(value)

          // Call props passed onChange
          if (onChange) {
            onChange(value as string)
          }
        }}
        invalid={isInvalid}
        {...addErrorDataAttribute(meta)}
      />
      {isInvalid ? (
        <FormFeedback customColor={errorLabelColor} variant='error'>
          {meta.error}
        </FormFeedback>
      ) : null}
    </div>
  )
}

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
